// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"343":"6edf0643","4316":"ad2866b8"}[chunkId] || chunkId) + "." + {"97":"18cbedee005461b9","343":"d8a7c6b6bdcdfe66","4316":"890f6f4190c9fdfb","6571":"bb819e5fe1814855","6926":"900b5af6f2c5fe8e"}[chunkId] + ".js";
};